import styled, { css } from 'styled-components';
var Checkbox = styled.input.withConfig({
  displayName: "elements__Checkbox",
  componentId: "sc-1ld0rrd-0"
})(["position:absolute;width:0;opacity:0;"]);
var Toggle = styled.span.withConfig({
  displayName: "elements__Toggle",
  componentId: "sc-1ld0rrd-1"
})(["display:inline-block;position:relative;width:3.8rem;height:2rem;border-radius:1rem;background:", ";border:1px solid ", ";cursor:pointer;pointer-events:none;&:before{content:'';display:block;position:absolute;top:0.1rem;left:0.2rem;cursor:pointer;height:1.6rem;width:1.6rem;border-radius:1.6rem;background:", ";box-shadow:0 2px 4px 0 rgba(0,0,0,0.15);transition:transform 250ms ease;transform:translateX(", ");will-change:transform;}", ";"], function (_ref) {
  var isChecked = _ref.isChecked,
      palette = _ref.theme.palette;
  return isChecked ? "".concat(palette.primary["default"], " linear-gradient(\n          0deg,\n          ").concat(palette.whiteOpacity(0), " 0%,\n          ").concat(palette.whiteOpacity(0.1), " 100%\n        )") : palette.lightGrey;
}, function (_ref2) {
  var isChecked = _ref2.isChecked,
      palette = _ref2.theme.palette;
  return isChecked ? palette.primary["default"] : palette.lightGrey;
}, function (_ref3) {
  var palette = _ref3.theme.palette;
  return palette.white;
}, function (_ref4) {
  var isChecked = _ref4.isChecked;
  return isChecked ? '1.7rem' : 0;
}, function (_ref5) {
  var readOnly = _ref5.readOnly;
  return readOnly ? css(["opacity:0.4;"]) : css(["&:active{&:before{width:3rem;left:", ";}}"], function (p) {
    return p.isChecked ? '0' : '6px';
  });
});
export { Checkbox, Toggle };